export default __webpack_public_path__ + "static/media/dhl.98998999.png";